export default __webpack_public_path__ + "static/media/BannerCsob.ca6bb250.jpg";